<template>
<div class="payslip-fields">
  <div class="top-bar">
    <span @click="goBack"><i class="left"></i></span>
    <span class="heading_new">Payslip Preferences</span>
  </div>
  <div class="inner">
    <div class="page-header">
      <div class="text">Paylief Fields</div>
      <div class="header-line"></div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="below-text">Below are the selected employee fields you want to show in Payslip.</div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="payslip-label">Employee Info</div>
        <br>
        <div v-for="(data,index) in employeeInfo" :key="index">
          <div class="check">
            <tl-checkbox />
            <div class="label-text">{{data}}</div>
          </div>
          <br>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="payslip-label">Bank Info</div>
        <br>
        <div v-for="(data,index) in bankInfo" :key="index">
          <div class="check">
            <tl-checkbox />
            <div class="label-text">{{data}}</div>
          </div>
          <br>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="payslip-label">Statutory Info</div>
        <br>
        <div v-for="(data,index) in statutoryInfo" :key="index">
          <div class="check">
            <tl-checkbox />
            <div class="label-text">{{data}}</div>
          </div>
          <br>
        </div>
      </div>
    </div>
    <div class="bttn-group">
      <!--bottom action button-->
      <bottom-action-container>
        <btn-skip @navClicked="skip"></btn-skip>
        <template slot="end">
          <btn-grp>
            <btn text="Previous" type="secondary" @click="$emit('stepNum',3)" />
            <btn text="Next" type="primary" @click="next"/>
          </btn-grp>
          </template>
      </bottom-action-container>
    </div>
  </div>
</div>
</template>

<script>
// import TlHeader2 from "@/components/headers/TlHeader2.vue";
export default {
  name: "PayslipFields",
  // components: {
  //   TlHeader2
  // },
  data() {
    return {
      employeeInfo: [
        "Employee Name",
        "Employee Number",
        "Date Joined",
        "Department",
        "Designation",
        "PAN"
      ],
      bankInfo: ["Payment Mode", "Bank Details"],
      statutoryInfo: ["UAN", "ESI Number"]
    };
  },
  methods: {
    skip() {
      this.$router.push(`/onboarding/entity/${this.$route.params.entity_index}/employees`);
    },
    next() {
      this.$router.push(`/onboarding/entity/${this.$route.params.entity_index}/employees`);
    }
  }
};
</script>

<style scoped>
.payslip-fields {
  width: 100%;
}

.top-bar {
    /* // height: 70px; */
    padding: 20px;
    background-color: #34c0be;
    display: flex;
}

.heading_new {
    font-family: Montserrat;
    font-size: 24px;
    font-weight: bold;
    color: #ffffff;
}

.left {
    border: solid white;
    border-width: 0 2px 2px 0;
    padding: 5px;
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
    margin-top: 9px;
    margin-right: 20px;
}

.horiz-line {
  border-bottom: 2px solid #34c0be;
}

.page-header {
  display: flex;
  width: 100%;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  margin-bottom: 24px;
}

.page-header .text {
  font-size: 16px;
  font-weight: 600;
  font-family: Montserrat;
  color: rgb(26, 25, 25);
  padding-right: 10px;
}

.page-header .header-line {
  border-bottom: 2px solid #34c0be;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
}

.below-text {
  height: 18px;
  font-family: Montserrat;
  font-size: 14px;
  color: #404040;
}

.payslip-label {
  font-size: 16px;
  font-weight: 600;
  font-family: Montserrat;
  color: rgb(26, 25, 25);
  margin-top: 24px;
}

.check {
  display: flex;
  align-self: center;
}

.bttn-group {
  margin-top: 30px;
}
</style>
